/**
 * Application Configuration
 *
 * Static build-time configuration constants.
 *
 */

export const APP_CONFIG = {
  /** Application name */
  name: 'AssetCAST',

  /** Base path for routing - must match next.config.js */
  basePath: '/assetcast',

  /** Service identifier for logging and monitoring */
  serviceId: 'assetcast-frontend',

  /** Application version */
  version: '1.0.0',
} as const;

/**
 * Storage Configuration
 * Prefixes for localStorage and sessionStorage keys
 */
export const STORAGE_CONFIG = {
  /**
   * Prefix for all localStorage keys
   * Pattern: {prefix}-{feature}
   * @example "assetcast-frontend-theme-mode", "assetcast-frontend-nav-visibility"
   */
  prefix: 'assetcast-frontend',

  keys: {
    theme: 'assetcast-frontend-theme-mode',
    navVisibility: 'assetcast-frontend-nav-visibility',
    topNavVisibility: 'assetcast-frontend-topnav-visibility',
    drawerOpen: 'assetcast-frontend-drawer-open',
  },
} as const;

/**
 * Authentication Configuration
 */
export const AUTH_CONFIG = {
  /**
   * Authentication provider base path
   * Must include /api/auth for NextAuth compatibility
   */
  basePath: `${APP_CONFIG.basePath}/api/auth`,

  /**
   * Default callback URL after sign in
   * Redirects authenticated users to the dashboard
   */
  signInCallbackUrl: `${APP_CONFIG.basePath}/dashboard`,

  /**
   * Sign in page path
   */
  signInUrl: `${APP_CONFIG.basePath}/auth/signin`,

  /**
   * Sign out callback URL - redirects to signin page after sign out
   */
  signOutCallbackUrl: `${APP_CONFIG.basePath}/auth/signin`,
} as const;

export { isDevelopment, isProduction, isTest } from '@/lib/env';
